import { Icon, Popover } from "@clarkinc/zest-design-system";
import { cls } from "cls";
import React, { FC } from "react";
import { Image } from "@wss/image";

const quickShippingPopoverId = "quick-shipping-popover-id";

interface QuickShipProps {
  restrictItemExpeditedShipping: boolean;
}

const QuickShip: FC<QuickShipProps> = ({ restrictItemExpeditedShipping }) => {
  return (
    <>
      <div
        className={cls(
          "relative",
          "flex",
          "w-full",
          "max-w-sm",
          "mb-4",
          "bg-white",
        )}
      >
        <Image
          className={cls("w-10", "h-10", "m-auto", "ml-0", "mr-2")}
          src="/uploads/design/2022/7/icon_quick-shipping.svg"
          alt=""
          loading="lazy"
          height={40}
          width={40}
        />
        <div>
          <h2 className={cls("m-0", "text-base", "font-bold")}>
            Quick Shipping
          </h2>
          <p className="m-0 inline">
            Usually ships in <span className="font-bold">1 business day</span>
          </p>
          <Popover className="align-text-top ml-1">
            <Popover.Trigger
              contentId={quickShippingPopoverId}
              className="flex"
            >
              <Icon
                name="ri-question-fill"
                aria-label="more information"
                className="fill-green-500 w-4 h-4"
              />
            </Popover.Trigger>
            <Popover.Content
              title="Estimated Shipping Time"
              id={quickShippingPopoverId}
            >
              <div id="delivery-info">
                Delivery time may vary depending on your location. Use the
                shipping calculator on the cart page to{" "}
                <strong>estimate</strong> arrival times by entering your zip
                code. If an order is time-sensitive, check with our customer
                service team.
              </div>
            </Popover.Content>
          </Popover>
        </div>
      </div>
      {restrictItemExpeditedShipping && (
        <p>Not eligible for expedited shipping</p>
      )}
    </>
  );
};

export default QuickShip;
